module.exports = __webpack_public_path__ + "static/Veneers 2 smile after-a4f1a8571e689916e8f8c791fc3a37a0.jpg";